import {
    SearchIcon,
    HistoryIcon,
    AddNewDocumentIcon,
    EditIcon,
    AppleIcon,
    WindowsIcon,
    RefreshIcon,
    DownloadCloudIcon
} from './Icons';

const icons = {
    SearchIcon,
    HistoryIcon,
    AddNewDocumentIcon,
    EditIcon,
    AppleIcon,
    WindowsIcon,
    RefreshIcon,
    DownloadCloudIcon
};

class IconInvoker {
    constructor (iconName, opts) {
        return new icons[iconName](opts);
    }
}

export default IconInvoker;


// WEBPACK FOOTER //
// ./src/components/Common/Icons/IconInvoker.js